/**
 * Bouton « paiement rapide » de la fiche produit (FLT-19464033).
 *
 * Le bouton est un submit du formulaire produit. Sans JavaScript il ajoute
 * simplement au panier — comportement dégradé acceptable, jamais un cul-de-sac.
 *
 * Avec JavaScript, on ajoute `return_to` au formulaire pour que Shopify
 * redirige vers le checkout après l'ajout, puis on soumet le formulaire *nativement*.
 * `HTMLFormElement.submit()` ne déclenche pas les écouteurs `submit`, ce qui
 * court-circuite volontairement l'ajout au panier en AJAX du thème : sans ça,
 * l'article serait ajouté sans que la redirection ait lieu.
 */
(function() {
  var FALLBACK_CHECKOUT_URL = '/checkout';

  function onClick(event) {
    var button = event.currentTarget;
    var form = button.form;
    if (!form || button.disabled) return;

    event.preventDefault();

    // Un second clic pendant la soumission relancerait le formulaire.
    if (button.dataset.submitting) return;
    button.dataset.submitting = 'true';
    button.setAttribute('aria-busy', 'true');

    var input = form.querySelector('input[name="return_to"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'return_to';
      form.appendChild(input);
    }
    input.value = button.dataset.checkoutUrl || FALLBACK_CHECKOUT_URL;

    form.submit();
  }

  /**
   * Variante épuisée : on masque le bouton plutôt que de le griser (demande
   * cliente du 15/09/2026). Grisé, il occupait la place du bouton « Alerte
   * disponibilité » inséré par l'app et le décalait vers le bas.
   *
   * `hidden` *et* `disabled` : le premier pour l'affichage (cf. la règle
   * `.fast-checkout[hidden]` de fast-checkout.css, nécessaire face au
   * `display: flex` du bouton), le second pour qu'il ne reste pas soumettable
   * au clavier tant qu'il est masqué.
   *
   * L'état initial vient de Liquid ; `variant:change` est l'événement que le
   * thème émet sur `document` à chaque changement de variante (theme.js), le
   * même que celui qui pilote déjà le bouton d'ajout au panier sticky.
   * `detail.variant` vaut `null` quand la combinaison d'options n'existe pas :
   * le bouton est alors masqué, comme l'ajout au panier est désactivé.
   */
  function setAvailability(button, isAvailable) {
    button.hidden = !isAvailable;
    button.disabled = !isAvailable;
  }

  function onVariantChange(event) {
    var variant = event.detail && event.detail.variant;
    var isAvailable = Boolean(variant && variant.available);

    Array.prototype.forEach.call(
      document.querySelectorAll('[data-fast-checkout]'),
      function(button) {
        setAvailability(button, isAvailable);
      }
    );
  }

  function init() {
    Array.prototype.forEach.call(
      document.querySelectorAll('[data-fast-checkout]'),
      function(button) {
        button.addEventListener('click', onClick);
      }
    );

    document.addEventListener('variant:change', onVariantChange);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
